// @ts-nocheck
import { MTableActions } from "@material-table/core";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import ResponsiveMaterialTable from "components/UI/MaterialTable/ResponsiveMaterialTable";
import { useAuth } from "hooks/useAuth";

import AddEarForm from "./AddEarForm/AddEar.modal";

export default function EARDetailsAccordion({ id }) {
  const [show, setShow] = useState(false);
  const tableRef = useRef();
  const { authToken, permissions } = useAuth();

  const onShow = () => {
    setShow(true);
  };

  const onHide = () => {
    setShow(false);
    tableRef.current.onQueryChange();
  };

  useEffect(() => {
    tableRef.current.onQueryChange();
  }, [id]);

  const columns = [
    {
      title: "EAR ID",
      field: "earid",
      cellStyle: { width: "10%", minWidth: "10%" },
      render: (rowData) => (
        <Link to={`/community/ear-reviews/details/${rowData?.earid}`}>
          {rowData?.earid}
        </Link>
      ),
    },
    {
      title: "Submitted On",
      field: "entrydate",
      render: (rowData) => moment.utc(rowData?.entrydate).format("MM/DD/YYYY"),
    },
    {
      title: "Escalated On",
      field: "release_date",
      render: (rowData) =>
        rowData?.release_date
          ? moment.utc(rowData?.release_date).format("MM/DD/YYYY")
          : "TBD",
    },
    {
      title: "Completion Date",
      field: "enddate",
      render: (rowData) =>
        rowData?.enddate ? (
          moment.utc(rowData?.enddate).format("MM/DD/YYYY")
        ) : (
          <>TBD</>
        ),
    },
    {
      title: "Status",
      field: "status",
    },
  ];
  const options = {
    sorting: true,
    search: false,
    columnsButton: true,
    padding: "dense",
    pageSize: 5,
  };

  return (
    <>
      <ResponsiveMaterialTable
        columns={columns}
        title={`EAR Reviews`}
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve, reject) => {
            // Extract the necessary information from the query object
            const { page, pageSize, search, filters, orderBy, orderDirection } =
              query;

            let newFilters = filters.map((filter) => {
              let value = "";
              if (Array.isArray(filter.value)) {
                value = filter.value;
              } else {
                value = filter.value.replace(/['"]+/g, "");
              }
              return `"${filter.column.field.replace(/\./g, "__")}":"${value}"`;
            });
            const params = {
              offset: page * pageSize,
              limit: pageSize,
              search: search,
              filters: newFilters,
              orderBy: orderBy?.field,
              orderDirection: orderDirection,
              product_id: id,
            };
            axios
              .get(
                `${process.env.REACT_APP_DJANGO_ENDPOINT}ear/current_product_ears/?${qs.stringify(params, { arrayFormat: "comma" })}`,
                {
                  withCredentials: true,
                  headers: {
                    Authorization: `Token ${authToken}`,
                  },
                },
              )
              .then((response) => {
                resolve({
                  data: response.data.results,
                  page: page,
                  totalCount: response.data.count,
                });
              })
              .catch((error) => {
                reject(error);
              });
          })
        }
        options={options}
        components={{
          Actions: (props) => (
            <span>
              <MTableActions {...props} />
            </span>
          ),
        }}
        actions={[
          {
            icon: "add",
            tooltip: "Add EAR Review",
            hidden: permissions?.role_type === "Lab",
            isFreeAction: true,
            onClick: onShow,
          },
        ]}
      />
      <AddEarForm show={show} onHide={onHide} product_id={id} />
    </>
  );
}
